import { createStore } from "redux"
import hgrReducer from "./reducers/hgr0221Reducers"

function configureStore(state = { content: null, st: "none" }) {
  return createStore(hgrReducer, state)
}

export default configureStore
